export default "__VITE_ASSET__BWaLhUiP__"